// Migrated from app/assets/javascripts/yellow.js
// Yellow layout (ticketshop) entrypoint

import 'libraries/jquery-global'
import 'popper.js'
import 'bootstrap'
import toastr from 'toastr'
window.toastr = toastr
import 'vendor/bootbox-4.3.0'
// resizer + iframeResizer.contentWindow loaded as sync <script> in layout
import FlipDown from 'vendor/flipdown'
window.FlipDown = FlipDown

// jQuery extensions
import 'vendor/jquery.prettyPhoto'
import 'vendor/jquery.prevent_double_click'

// jQuery validation
import 'jquery-validation'

import 'libraries/idle'

// AT-1225: de kassabon in de rechterkolom van de productstap. Deze import verdween bij
// de Vite-migratie (b9961795e, AT-539): de views verloren toen hun
// javascript_include_tag "orders/products_step" en alleen red en red2 kregen de bundel
// terug. De markup (aside.kassabon met .cash-receipt) stond al die tijd leeg in yellow.
//
// locale moet erbij en ervoor: products-step roept translate() aan voor zijn labels.
// De data (__locale) laadt de view al als los script, alleen de helper ontbrak hier.
import 'libraries/locale'
import 'libraries/products-step'

// Yellow legacy inline code
import 'libraries/yellow-legacy'

import { Application } from "@hotwired/stimulus"
import PostcodeLookupController from '../controllers/postcode_lookup_controller'
const application = Application.start()
application.register("postcode-lookup", PostcodeLookupController)
